module.exports = __webpack_public_path__ + "img/partner2.278353ec.png";